<div class="cashcut-item">
  <div class="left">
    <h4>#{{ cashcutListItem.kassenschnittNr }}</h4>
  </div>
  <div class="middle">
    <div class="pos-name">
      {{
        cashcutListItem.posName ? cashcutListItem.posName : cashcutListItem.id
      }}
    </div>
    <div class="device">
      <small>
        {{ cashcutListItem.deviceId }}
      </small>
    </div>
  </div>
  <div class="right">
    <ng-container *ngIf="currentLanguage$ | async as language">
      <div class="date">
        {{
          cashcutListItem.editedAt | date: "shortDate":undefined:language.key
        }}
      </div>
      <div class="time">
        <small>
          {{
            cashcutListItem.editedAt | date: "mediumTime":undefined:language.key
          }}
        </small>
      </div>
    </ng-container>
  </div>
</div>
